<template>
  <client-only>
    <span class="sr-only" role="status">Page {{ message }} chargé</span>
  </client-only>
  <a href="#content" class="h-status peer sr-only focus:not-sr-only">
    Aller au contenu
  </a>

  <AppHeader />

  <div
    id="content"
    class="flex flex-col overflow-y-auto peer-focus:[--height-status:24px]"
    :class="{
      'h-container': !route.meta.header,
      'laptop:h-container h-container-mobile': route.meta.header,
    }"
  >
    <main class="mb-xl">
      <NuxtPage />
    </main>

    <AppFooter />
  </div>

  <Teleport :to="appStore.teleport">
    <GSnackbar
      :open="snackbarStore.open"
      :error="snackbarStore.type === snackbar.TYPE_ERROR"
      :message="snackbarStore.message"
      :action="snackbarStore.action"
      :close="snackbarStore.close"
      @action="snackbar.onAction()"
      @close="snackbar.onClose()"
    />
  </Teleport>
</template>

<script setup>
useHead({
  htmlAttrs: {
    lang: "fr",
  },
});

useHead({
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Le Réseau des Agendas",
        url: "https://agenda.org/",
      }),
    },
  ],
});

useSeoMeta({
  title: "Agenda.org - Le réseau des agendas",
  description:
    "Partenaire de vos sorties en France, Suisse et Belgique. Trouvez les événements autour de vous sur l'un de nos 10 agendas thématiques.",
});

usePreloadFonts();

const { message } = useRouteAnnouncer();

const route = useRoute();
const snackbar = useSnackbar();
const snackbarStore = useSnackbarStore();
const appStore = useAppStore();

useResumeAuth();
</script>
